import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import GenerateTransactionsVM from './GenerateTransactionsVM';
import { observer } from 'mobx-react';
import Loading from '../../../App/Components/Loading/Loading';
import { TextConstants } from '../../../Common/TextConstants';
import RawGenericTransactionLookup from '../../Transactions/Models/Lookups/RawGenericTransactionLookup';
import InfoLabelHover from '../../../Common/Components/InfoLabelHover/InfoLabelHover';
import GenerateNewManualTransactionComponent from '../Components/GenerateNewManualTransactionComponent';
import { GenerateTransactions } from '../../../AccessControl/Models/Commands/Security/Roles';

@observer
export default class GenerateTransactionsView extends Views.ViewBase<GenerateTransactionsVM> {

    constructor(props: unknown) {
        super("Generate Transactions", GenerateTransactionsVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.displayGenerateNewTransactionComponent &&
                    <>
                        <GenerateNewManualTransactionComponent
                            viewModel={this.viewModel}
                            onBack={() => this.viewModel.backToTransactionsPage()}
                            onSave={() => this.viewModel.saveTransaction()}>
                        </GenerateNewManualTransactionComponent>
                    </>}

                {!this.viewModel.displayGenerateNewTransactionComponent &&
                    <>
                        <Neo.Card title={TextConstants.Titles.Transactions} className="m-1">
                            <Neo.Form onSubmit={() => this.viewModel.pageManager.refreshData()}>
                                <Neo.GridLayout md={6}>
                                    <Neo.FormGroup label={TextConstants.Labels.Broker} bindContext={this.viewModel.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName}>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                            bind={this.viewModel.transactionInterceptionSearchCriteria.meta.staticServiceProviderFileGroupingID}
                                            bindDisplay={this.viewModel.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName}
                                            displayMember={"serviceProviderGroupingName"}
                                            items={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                                                .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                        />
                                    </Neo.FormGroup>
                                    <Neo.FormGroup bindContext={this.viewModel.transactionInterceptionSearchCriteria.meta.clientAccountNumber}
                                        label={TextConstants.Labels.ClientNumber}>
                                        <Neo.AutoCompleteDropDown
                                            minCharacters={3}
                                            delayMs={1500}   
                                            className="customAutoCompleteDropDown"
                                            bind={this.viewModel.transactionInterceptionSearchCriteria.meta.clientAccountNumber}
                                            bindDisplay={this.viewModel.transactionInterceptionSearchCriteria.meta.clientAccountNumber}
                                            displayMember={"clientDescription"}
                                            items={this.viewModel.filteredClientAccounts}
                                            itemSource={async (searchText) => this.viewModel.clientAccounts.filter(clientAccount => clientAccount.clientDescription.toLowerCase().includes(searchText.toLowerCase()))}
                                        />
                                    </Neo.FormGroup>
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.Account}
                                        bind={this.viewModel.transactionInterceptionSearchCriteria.meta.rawAccountNumber}
                                    />
                                    <Neo.FormGroup label={TextConstants.Labels.Event} bindContext={this.viewModel.transactionInterceptionSearchCriteria.meta.eventName} >
                                        <Neo.AutoCompleteDropDown
                                            minCharacters={3}
                                            delayMs={1500}
                                            bind={this.viewModel.transactionInterceptionSearchCriteria.meta.eventID}
                                            bindDisplay={this.viewModel.transactionInterceptionSearchCriteria.meta.eventName}
                                            displayMember={"staticEventName"}
                                            items={this.viewModel.filteredEvents}
                                            itemSource={async (searchText) => this.viewModel.events.filter(event => event.staticEventName?.toLowerCase().includes(searchText.toLowerCase()))}
                                        />
                                    </Neo.FormGroup>
                                    <Neo.FormGroup label={TextConstants.Labels.InstrumentDescription} bindContext={this.viewModel.transactionInterceptionSearchCriteria.meta.instrument} >
                                        <Neo.AutoCompleteDropDown
                                            minCharacters={3}
                                            delayMs={1500}
                                            bind={this.viewModel.transactionInterceptionSearchCriteria.meta.instrumentID}
                                            bindDisplay={this.viewModel.transactionInterceptionSearchCriteria.meta.instrument}
                                            displayMember={"description"}
                                            items={this.viewModel.filteredInstruments}
                    i                       itemSource={async (searchText) => this.viewModel.instruments.filter(instrument => instrument.description?.toLowerCase().includes(searchText.toLowerCase()))}
                                        />
                                    </Neo.FormGroup>
                                    <Neo.Button
                                        isSubmit
                                        variant="primary"
                                        className="form-btn">
                                        {TextConstants.Buttons.Search}
                                    </Neo.Button>
                                </Neo.GridLayout>
                                <Neo.GridLayout md={4}>
                                    <Neo.FormGroup
                                        appendText="fa-calendar"
                                        label={TextConstants.Labels.StartDate}
                                        bind={this.viewModel.transactionInterceptionSearchCriteria.meta.rangeStartDate}
                                    />
                                    <Neo.FormGroup
                                        appendText="fa-calendar"
                                        label={TextConstants.Labels.EndDate}
                                        bind={this.viewModel.transactionInterceptionSearchCriteria.meta.rangeEndDate}
                                    />
                                </Neo.GridLayout>
                            </Neo.Form>
                        </Neo.Card>

                    </>}
                {this.viewModel.pageManager.totalRecords > 0 && this.viewModel.transactionInterceptionSearchCriteria.staticServiceProviderFileGroupingID > 0 &&

                    <Neo.Card>
                        <div className="inner-container">
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <NeoGrid.Grid<RawGenericTransactionLookup> className={"table-striped"}>
                                    {(data, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column display={meta.eventDate} label={TextConstants.Labels.EventDate} />
                                            <NeoGrid.Column display={meta.eventTime} label={TextConstants.Labels.EventTime} />
                                            <NeoGrid.Column display={meta.clientNumber} label={TextConstants.Labels.ClientNumber} />
                                            <NeoGrid.Column display={meta.stockbrokerAccount} />
                                            <NeoGrid.Column display={meta.eventName} label={TextConstants.Labels.EventName} />
                                            <NeoGrid.Column display={meta.buyOrSell} />
                                            <NeoGrid.Column display={meta.eventID} label={TextConstants.Labels.EventID} />
                                            <NeoGrid.Column display={meta.relatedEventID} label={TextConstants.Labels.RelatedTrasactionID} />
                                            <NeoGrid.Column display={meta.instrumentDescription} label={TextConstants.Labels.InstrumentDescription} />
                                            <NeoGrid.Column display={meta.ticker} label={TextConstants.Labels.TickerSymbol} />
                                            <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                                            <NeoGrid.Column display={meta.currency} label={TextConstants.Labels.InstrumentCurrency} />
                                            <NeoGrid.Column display={meta.marketPrice} label={<InfoLabelHover title={TextConstants.Labels.MarketPrice} content={TextConstants.Tooltips.MarketValueTooltip} />} cellClassName="text-right" />
                                            <NeoGrid.Column display={meta.unitPrice} label={<InfoLabelHover title={TextConstants.Labels.UnitPrice} content={TextConstants.Tooltips.UnitPriceTooltip} />} cellClassName="text-right" />
                                            <NeoGrid.Column display={meta.quantity} label={TextConstants.Labels.Quantity} cellClassName="text-right" />
                                            <NeoGrid.Column display={meta.amount} label={<InfoLabelHover title={TextConstants.Labels.Amount} content={TextConstants.Tooltips.AmountTooltip} />} cellClassName="text-right" />
                                            <NeoGrid.Column display={meta.amountUSD} label={<InfoLabelHover title={TextConstants.Labels.AmountNC} content={TextConstants.Tooltips.AmountUSD} />} cellClassName="text-right" />
                                            <NeoGrid.Column display={meta.isExcludedInd} label={TextConstants.Labels.Excluded} />
                                            <NeoGrid.Column display={meta.isReversalInd} label={TextConstants.Labels.Reversal} />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>

                        </div>
                    </Neo.Card>

                }
                {!this.viewModel.displayGenerateNewTransactionComponent &&
                    <>
                        <Neo.Card title="Pending Transactions">
                            <div className="row float-right">
                                {this.viewModel.authorisationService.hasRole(GenerateTransactions.AddNew) &&
                                    <div className="col pb-3">
                                        <Neo.Button
                                            variant="secondary" className="form-btn mt-0"
                                            onClick={() => this.viewModel.showGenerateNewTransactionComponent()}
                                            text={TextConstants.Buttons.AddNewTransaction}>
                                        </Neo.Button>
                                    </div>
                                }
                            </div>

                            {this.viewModel.pendingTransactions.length > 0 &&
                                <div>
                                    <NeoGrid.Grid items={this.viewModel.pendingTransactions} className="table-striped">
                                        {(data, meta) =>
                                            <NeoGrid.Row>
                                                <NeoGrid.Column display={meta.isCashInd} label={TextConstants.Labels.Cash} />
                                                <NeoGrid.Column display={meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker} />
                                                <NeoGrid.Column display={meta.rawAccountID} label={TextConstants.Labels.AccountNumber} />
                                                <NeoGrid.Column display={meta.securityCode} label={TextConstants.Labels.SecurityCode} />
                                                <NeoGrid.Column display={meta.eventType} label={TextConstants.Labels.EventType} />
                                                <NeoGrid.Column display={meta.corporateActionType} label={TextConstants.Labels.CorporateActionType} />
                                                <NeoGrid.Column display={meta.dateTimeEvent} label={TextConstants.Labels.Date} />
                                                <NeoGrid.Column display={meta.instrumentCurrencyCode} label={TextConstants.Labels.InstrumentCurrency} />
                                                <NeoGrid.Column display={meta.transactionQuantity} label={TextConstants.Labels.TransactionQuantity} />
                                                <NeoGrid.Column display={meta.transactionAmount} label={TextConstants.Labels.TransactionAmount} />
                                                <NeoGrid.Column display={meta.isReversal} label={TextConstants.Labels.Reversal} />
                                            </NeoGrid.Row>}
                                    </NeoGrid.Grid>
                                    <div className="row float-right">
                                        <div className="col pt-3">
                                            <Neo.Button
                                                variant="primary" className="form-btn mt-0"
                                                text={TextConstants.Buttons.ProcessTransactions}
                                                onClick={() => this.viewModel.processPendingTransactions(this.viewModel.pendingTransactions)}>

                                            </Neo.Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Neo.Card>
                    </>

                }

            </ >
        );
    }
}